<script>
        let isMobile = false;

// Función para verificar si el dispositivo es móvil
function checkIsMobile() {
  isMobile = window.innerWidth <= 1000; // Puedes ajustar el valor según tus necesidades
}

// Llama a la función al cargar la página
checkIsMobile();

// Escucha el evento de cambio de tamaño de la ventana para actualizar el valor
window.addEventListener('resize', checkIsMobile);
</script>
<header>
<nav class="navbar navbar-expand-lg navbar-light custom-navbar">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="col-7 navbar-toggler no-border" data-toggle="collapse" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <img src="img/icema.png" width="50%" id="logo" alt="LogoIcema">
    </div>
    <div class="collapse navbar-collapse custom-navbar" id="navbarNav">
      <ul class="col-12 navbar-nav">
        {#if !isMobile}
            <li class="col-lg-3 nav-item-active">
                <img src="img/icema.png" width="50%" id="logo" alt="LogoIcema">
            </li>
        {/if}
        <li class="col-12 col-lg-3 nav-item active">
          <a class="nav-link boton-nav" href="#nostros">Nosotros</a>
        </li>
        <li class="col-12 col-lg-3 nav-item">
          <a class="nav-link boton-nav" href="#productos">Productos</a>
        </li>
        <li class="col-12 col-lg-2 nav-item">
          <a class="nav-link boton-nav" href="#contacto">Contacto</a>
        </li>
        {#if !isMobile}
            <li class="col-lg-1 nav-item">
            </li>
        {/if}
      </ul>
    </div>
  </nav>
</header>
<style>
    #logo{
        max-width: 225px;
    }    
    .custom-navbar {
    background-color: transparent; /* Fondo transparente */
    width: 100%; /* Ancho del 100% */
  }
  .no-border{
    border:0px !important;
  }
  .boton-nav{
    border: solid 1px rgba(0,0,255,0.9);
    border-radius: 10px;
    background-color: rgba(255,255,255,0.4);
    padding: 5px !important;
    margin-top:5px;
  }
</style>